module.exports = __webpack_public_path__ + "stylesheets/logo_b25a417656b629e0999b721c87034413.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/logo.less
// module id = wCd9
// module chunks = 153